import React from 'react';

// Plain-text content of a React node tree — header cells may contain
// inline markup (links, bold, code).
function textOf(node) {
  if (node === null || node === undefined || typeof node === 'boolean')
    return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(textOf).join('');
  if (node.props) return textOf(node.props.children);
  return '';
}

const isUs = text => text.trim().toLowerCase() === 'travelfeed';

const withClass = (existing, added) =>
  [added, existing].filter(Boolean).join(' ') || undefined;

// Markdown tables in blog guides: wraps them in `.tf-table-block`, the
// paper-card comparison ledger styled with the rest of the article
// typography in ArticleBody.js. Comparison tables get the teal "that's
// us" wash automatically — on the row whose first cell is TravelFeed,
// or the column whose header is.
export default function GuideTable({ children, ...props }) {
  const sections = React.Children.toArray(children);

  const headRow = sections
    .filter(s => s.type === 'thead')
    .flatMap(s => React.Children.toArray(s.props.children))
    .find(r => r.type === 'tr');
  const labels = headRow
    ? React.Children.toArray(headRow.props.children).map(textOf)
    : [];
  const usColumn = labels.findIndex(isUs);

  const mapRow = (row, isBody) => {
    if (row.type !== 'tr') return row;
    const cells = React.Children.toArray(row.props.children);
    const usRow = isBody && cells.length > 0 && isUs(textOf(cells[0]));
    return React.cloneElement(
      row,
      usRow
        ? { className: withClass(row.props.className, 'tf-row-us') }
        : undefined,
      cells.map((cell, i) => {
        if (cell.type !== 'td' && cell.type !== 'th') return cell;
        if (i !== usColumn) return cell;
        return React.cloneElement(cell, {
          className: withClass(cell.props.className, 'tf-col-us'),
        });
      }),
    );
  };

  return (
    <div className="tf-table-block">
      <table {...props}>
        {sections.map(section => {
          if (section.type !== 'thead' && section.type !== 'tbody')
            return section;
          const isBody = section.type === 'tbody';
          return React.cloneElement(
            section,
            undefined,
            React.Children.toArray(section.props.children).map(row =>
              mapRow(row, isBody),
            ),
          );
        })}
      </table>
    </div>
  );
}
